import React from 'react'

import { useTranslation } from 'react-i18next'

import NonIdealState from '@components/shared/NonIdealState'
import PageRoutes from '@utils/page-routes'

const DashboardNeedPremium: React.FC = () => {
  const { t } = useTranslation()
  return (
    <NonIdealState
      icon="upgrade"
      title={t('content.dashboardUpgrade.title')}
      subtitle={t('content.dashboardUpgrade.subtitle')}
      action={{
        type: 'link',
        href: PageRoutes.purchaseAnnual(),
        text: t('content.dashboardUpgrade.cta'),
        external: true,
      }}
    />
  )
}

export default DashboardNeedPremium
